if (!customElements.get('family-reviews')) {
  customElements.define('family-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-review-track]');
      this.controls = this.querySelector('[data-review-controls]');
      if (!this.track || !this.controls) return;

      this.previous = this.querySelector('[data-review-previous]');
      this.next = this.querySelector('[data-review-next]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const behavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      const move = (direction) => {
        const card = this.track.querySelector('.family-reviews__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: behavior() });
      };
      const update = () => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.controls.hidden = maximum <= 1;
        this.previous.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft >= maximum - 1;
      };

      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.addEventListener('shopify:block:select', (event) => {
        const card = event.target.closest('.family-reviews__card');
        if (card) this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: behavior() });
      }, options);
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.track);
      update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
